import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, XCircle, ArrowRight } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [bookingId, setBookingId] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let cancel = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancel) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          setBookingId(data.booking_id);
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch { /* retry */ }
      attempts.current += 1;
      if (attempts.current >= 8) { setStatus("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancel = true; };
  }, [sessionId]);

  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {status === "checking" && (
        <>
          <div className="overline mb-6">— A verificar pagamento</div>
          <h1 className="font-display text-5xl text-[#003D4C]">Quase…</h1>
          <p className="text-[#003D4C]/65 mt-4">A confirmar com o Stripe.</p>
          <div className="mt-10 mx-auto w-10 h-10 border border-[#003D4C]/20 border-t-[#BE3A34] rounded-full animate-spin" data-testid="payment-spinner" />
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle size={64} weight="light" color="#6BB9B8" className="mx-auto" />
          <h1 className="font-display text-5xl mt-6 text-[#003D4C]">Reserva confirmada.</h1>
          <p className="text-[#003D4C]/70 mt-3">Enviámos os detalhes para o seu email. Apresente-se 5 minutos antes da hora.</p>
          {bookingId && <p className="overline mt-6">Ref. {bookingId}</p>}
          <div className="flex justify-center gap-3 mt-10">
            <Link to="/my-bookings" className="btn-hot px-6 py-3 inline-flex items-center gap-2" data-testid="success-go-bookings">
              Ver as minhas reservas <ArrowRight size={16} weight="light" />
            </Link>
            <Link to="/book" className="btn-ghost px-6 py-3" data-testid="success-book-again">Nova reserva</Link>
          </div>
        </>
      )}
      {(status === "expired" || status === "failed") && (
        <>
          <XCircle size={64} weight="light" color="#BE3A34" className="mx-auto" />
          <h1 className="font-display text-5xl mt-6 text-[#003D4C]">Não foi possível confirmar.</h1>
          <p className="text-[#003D4C]/70 mt-3">A sessão de pagamento expirou ou foi cancelada. Pode tentar de novo.</p>
          <Link to="/book" className="btn-hot inline-block mt-10 px-6 py-3" data-testid="failed-retry">Tentar novamente</Link>
        </>
      )}
    </div>
  );
}
